<template>
  <div class="tw-flex tw-items-baseline tw-gap-2 tw-mb-2">
    <div
      :class="
        inFloatingSidepane ? 'tw-text-sm tw-font-medium' : 'sf-title sf-font-l'
      "
    >
      {{ I18n.t('companies_overview.filters.filters') }}
    </div>

    <div v-if="segmentLoading" class="sf-icon sf-spinner" />

    <div
      v-if="activeFiltersCount"
      :class="
        inFloatingSidepane
          ? 'tw-text-sf-slate-light-2 tw-text-[12px] [font-variant:small-caps]'
          : 'tw-text-neutral-500 tw-text-xs'
      "
    >
      {{
        I18n.t('companies_overview.filters_applied_count', {
          count: activeFiltersCount,
        })
      }}
    </div>

    <SfButtonDs
      v-tooltip="I18n.t('companies_overview.filters.add_filter_button')"
      variant="tertiary"
      icon-only
      icon-before="plus"
      :aria-label="I18n.t('companies_overview.filters.add_filter_button')"
      @click="$emit('add')"
    />
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'
import { useInsightsLayoutContext } from '@app/insights/composables/use-insights-layout-context'

const I18n = useI18n()

defineOptions({ name: 'FiltersSectionHeader' })

defineProps<{
  activeFiltersCount: number
  segmentLoading: boolean
}>()

defineEmits<{
  add: []
}>()

const { inFloatingSidepane } = useInsightsLayoutContext()
</script>
